"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ko = require("knockout");
var validatedViewModel_1 = require("../viewModels/base/validatedViewModel");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var ChatRemoveButtonComponent = (function (_super) {
    __extends(ChatRemoveButtonComponent, _super);
    function ChatRemoveButtonComponent(params) {
        _super.call(this, params);
        this.userId = params.userId;
    }
    ChatRemoveButtonComponent.prototype.deleteChat = function () {
        var _this = this;
        this.init();
        app.f7.confirm('Вы уверены что хотите удалить диалог?', 'Подтверждение', function () {
            _this.init();
            _this.processing(true);
            ajaxUtils_1.AjaxUtils.post("pm/deleteChat", { userId: _this.userId })
                .done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                alert("Вы удалили диалог.");
                ChatRemoveButtonComponent.reloadNotificationCount();
                setTimeout(function () {
                    var url = window.location.pathname;
                    _this.redirectToPage(url);
                }, 2000);
            })
                .always(function () {
                _this.processing(false);
            });
        }, function () { });
    };
    ChatRemoveButtonComponent.prototype.init = function () {
        this.errorMessages([]);
        app.closeModal();
    };
    ChatRemoveButtonComponent.reloadNotificationCount = function () {
        var component = window["AppComponents"].Notifications;
        if (component) {
            component.reload();
        }
    };
    return ChatRemoveButtonComponent;
}(validatedViewModel_1.default));
ko.components.register("chat-remove-buttton", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ChatRemoveButtonComponent;
//# sourceMappingURL=mobileChatRemoveButton.js.map